export default __webpack_public_path__ + "static/media/CopyRoutine.6ab7a990.svg";